import { BASE_URL } from "@/services/api/base";

export const getPersonnelsEndpoint = `${BASE_URL}/Workers/GetLoaWorkers`;

export const getPersonnelsByReferenceNumberEndpoint = `${BASE_URL}/Workers/GetLoaWorkersWithFilter`;
